<template>
  <div class="shape-options-setting-dialog">
    <div class="content-group-default">
      <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex"
export default {
  name: "text-options-data",
  components: { controlWidthAndSizeAndZindex },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1", "2"],
      this1: this,
      collapseActiveNames: ["1", "2"],
      activeType: 1,
      sliderMax: 360
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    }
  },
  mounted() {}
}
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}
</style>
